import Vue from 'vue';
import {
  Input,
  Field,
  Collapse,
  Loading,
  Navbar,
  Snackbar,
} from 'buefy';
import VuePrlx from 'vue-prlx';
import 'material-icons/iconfont/material-icons.css';

import App from './App.vue';
import router from './router';

const infiniteScroll = require('vue-infinite-scroll');

// Buefy Components
Vue.use(Collapse);
Vue.use(Snackbar);
Vue.use(Input);
Vue.use(Loading);
Vue.use(Field);
Vue.use(Navbar);
Vue.use(Snackbar);

// Other Components
Vue.use(VuePrlx);
Vue.use(infiniteScroll);

Vue.config.productionTip = false;

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
